import { render, staticRenderFns } from "./RemoteOperationClose.vue?vue&type=template&id=53a755cf&scoped=true&lang=pug&"
import script from "./RemoteOperationClose.vue?vue&type=script&lang=ts&"
export * from "./RemoteOperationClose.vue?vue&type=script&lang=ts&"
import style0 from "./RemoteOperationClose.vue?vue&type=style&index=0&id=53a755cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a755cf",
  null
  
)

export default component.exports